import React, { useState } from "react";
import HENGE from "@henge-inc/global-types";
import { i as i_v1_1 } from "@henge-inc/ui/v1_1";

export type ImageControllerProps = {
  label: string;
  rename?: {
    prefix: string;
  };
  value: string | undefined;
  setValue: (value: File) => void;
};

export const ImageController = ({
  label,
  rename,
  value,
  setValue,
}: ImageControllerProps) => {
  const [hover, setHover] = useState(false);

  const [imageData, setImageData] = useState<string | undefined>(value);

  return (
    <div className="w-full">
      <label
        className="aspect-square w-full flex flex-col items-center justify-center gap-2 cursor-pointer rounded-lg transition-all border border-dashed border-[var(--border-tertiary)] hover:border-[var(--blue200)]"
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        {imageData ? (
          <div className="relative w-full h-full">
            <img
              src={imageData}
              alt={label}
              className="w-full h-full object-cover rounded-lg"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-[var(--black)] bg-opacity-80 opacity-0 hover:opacity-100 transition-opacity rounded-lg">
              <i_v1_1.UploadCloud
                kind={HENGE.ICON_KIND.regular}
                size={HENGE.DETAILED_SIZE.xSmall}
                colour={HENGE.SEMANTIC_TEXT_COLOUR["text-mono-inverted"]}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              opacity: hover ? 1 : 0,
              transition: "all 0.15s ease-in-out",
            }}
          >
            <i_v1_1.UploadCloud
              kind={HENGE.ICON_KIND.regular}
              size={HENGE.DETAILED_SIZE.xSmall}
              colour={HENGE.MAIN_COLOUR.blue200}
            />
          </div>
        )}

        <input
          type="file"
          className="hidden"
          accept="image/*"
          onChange={(e) => {
            let file = e.target.files?.[0];
            if (file) {
              if (rename) {
                const extension = file.name.substring(
                  file.name.lastIndexOf(".") + 1,
                );
                file = new File([file], `${rename.prefix}.${extension}`, {
                  type: file.type,
                });
              }

              setValue(file);

              const reader = new FileReader();
              reader.onloadend = () => {
                setImageData(reader.result as string);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
      </label>
    </div>
  );
};
